
import { Vue, Component, Prop } from 'vue-property-decorator';
import { InputValidationRules } from 'vuetify';

@Component
export default class ExpandableInput extends Vue {
  @Prop({ default: '' }) value!: string;

  @Prop({ default: '' }) label!: string;

  @Prop({ default: () => [] }) rules!: InputValidationRules;

  @Prop({ default: '35' }) maxlength!: string | number;

  @Prop({ default: true }) clearable!: boolean;

  @Prop({ default: '' }) id!: string;

  @Prop({ default: '' }) ariaLabel!: string;

  @Prop({ default: '' }) dataCy!: string;

  @Prop({ default: true }) outlined!: boolean;

  @Prop({ default: true }) dense!: boolean;

  @Prop({ default: 96 }) maxExpandHeight!: number;

  private isExpanded = false;

  mounted(): void {
    const el = this.getTextareaEl();
    if (el) el.setAttribute('wrap', 'off');
  }

  private handleInput(val: string): void {
    this.$emit('input', val);
    if (this.isExpanded) {
      this.$nextTick(() => this.resize());
    }
  }

  private handleFocus(e: Event): void {
    const el = this.getTextareaEl();
    if (el) el.setAttribute('wrap', 'soft');
    this.isExpanded = true;
    this.$nextTick(() => this.resize());
    this.$emit('focus', e);
  }

  private handleBlur(e: Event): void {
    const el = this.getTextareaEl();
    if (el) el.setAttribute('wrap', 'off');

    if (this.value && /[\r\n]/.test(this.value)) {
      this.$emit('input', this.value.replace(/[\r\n]+/g, ' ').trim());
    }

    this.isExpanded = false;
    this.resetHeight();
    this.$emit('blur', e);
  }

  private resize(): void {
    const el = this.getTextareaEl();
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.min(el.scrollHeight, this.maxExpandHeight)}px`;
  }

  private resetHeight(): void {
    const el = this.getTextareaEl();
    if (!el) return;
    el.style.height = '';
  }

  private getTextareaEl(): HTMLTextAreaElement | null {
    const ref = this.$refs.textarea as Vue | undefined;
    return ref?.$el?.querySelector('textarea') || null;
  }
}
